import styled from '@emotion/styled';
import { fromTheme } from '@kyruus/ui-theme';
import { BREAKPOINTS } from '../../lib/constants';

export const InsurancesAcceptedContainer = styled.div`
  h2 {
    margin: 0;
    font-weight: ${fromTheme('font_weight_bolder')};
    font-size: ${fromTheme('font_size_heading_4')};
    color: ${fromTheme('color_text')};

    @media screen and (max-width: ${BREAKPOINTS.medium}px) {
      margin-bottom: ${fromTheme('spacing_small')};
    }
  }
`;

export const DisclaimerContainer = styled.div`
  margin-top: ${fromTheme('spacing_large')};
`;
